/**
* @license Apache-2.0
*
* Copyright (c) 2023 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Resolves the index offset of the first element indexed by a normalized multi-slice.
*
* @private
* @param {MultiSlice} slice - normalized multi-slice object
* @param {IntegerArray} strides - array strides
* @param {NonNegativeInteger} offset - array index offset
* @returns {NonNegativeInteger} index offset of the first element indexed by a normalized multi-slice object
*/
function sliceStart( slice, strides, offset ) {
	var data;
	var idx;
	var i;

	data = slice.data;
	idx = offset;
	for ( i = 0; i < data.length; i++ ) {
		idx += strides[ i ] * data[ i ].start;
	}
	return idx;
}


// EXPORTS //

export default sliceStart;
